/** @jsxImportSource @emotion/react */

import { ReactNode } from 'react'
import { ToastContainer, Slide, toast as toastify } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { ReactComponent as CheckIcon } from 'assets/icons/check.svg'

import * as classes from './styles'

export const Toast = () => (
  <ToastContainer
    hideProgressBar
    closeOnClick
    closeButton={false}
    limit={5}
    position="top-right"
    css={classes.container}
    transition={Slide}
  />
)

export const toast = {
  success: (content: ReactNode) =>
    toastify.success(content, {
      autoClose: 3000,
      icon: () => <CheckIcon />,
    }),
  error: (content: ReactNode) =>
    toastify.error(content, {
      autoClose: 5000,
    }),
}
